import { Component, OnChanges, Input, SimpleChanges, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService, ApUndoableOperationService } from 'webcommon/core-ui';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FcItemModalContext } from '../../../models';
import { FcItemListBaseComponent } from '../../generic';
import { FcPharmacyClearinghouseListItemDto, FcProviderTypeDataDto } from 'webcommon/shared';

@Component({
    providers: [ApAlertService, FcListValidationService],
    selector: 'fc-pharmacy-clearinghouse-providers-tab',
    templateUrl: './fc-pharmacy-clearinghouse-providers-tab.component.html',
    styleUrls: ['./fc-pharmacy-clearinghouse-providers-tab.component.less'],
})
export class FcPharmacyClearinghouseProviderTabComponent extends FcItemListBaseComponent implements OnChanges {
    @Input() baseId: string;
    @Input() form: FormGroup;
    @Input() listItem: FcPharmacyClearinghouseListItemDto;
    @Input() isSubmitted = false;
    @Input() itemContext: FcItemModalContext;

    public selectedProvidersPks: string[] = [];
    public providersNames: string[];

    // Form Controls
    public providersUidControl: FormControl<string[] | null> = new FormControl([]);

    constructor(
        injector: Injector,
        protected apUndoableOperationService: ApUndoableOperationService) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.form != null) {
            this.addControlsToForm();
        }
        if (changes.itemContext != null || changes.form != null || changes.listItem != null) {
            this.setForm();
        }
    }

    public onProviderDataPopulate(event: FcProviderTypeDataDto[]) {
        this.providersNames = [];
        event.forEach((provider: FcProviderTypeDataDto) => {
            this.providersNames.push(provider.FormattedInternalName);
        });
    }

    public deleteProviderRow(index: number): void {
        const refreshProviders = [...this.selectedProvidersPks];
        refreshProviders.splice(index, 1);
        this.selectedProvidersPks = refreshProviders;
        this.form.markAsDirty();
    }

    private addControlsToForm(): void {
        this.form.addControl('providersUid', this.providersUidControl);
    }

    private setForm(): void {
        this.selectedProvidersPks = this.getFindControlValue(this.listItem.Providers);
    }
}
